export default {
  title: 'Create API key',
  reveal_warning: 'Store this key now — it will not be shown again.',
  form: {
    name: 'Name',
    name_placeholder: 'e.g. Production key',
  },
  buttons: {
    cancel: 'Cancel',
    create: 'Create',
    done: 'Done',
  },
  toasts: {
    error: 'Could not create the key. Please try again.',
  },
};
